// Pure data + display helpers for the parsed-fields panel.
// No React, no state — safe to import anywhere.

export const CURRENCY_FIELDS = new Set(["offerPrice", "earnestMoney"]);

export const FIELD_LABELS = {
  offerPrice: "Offer Price",
  earnestMoney: "Earnest Money",
  closingdate: "Closing Date",
  propertyaddress: "Property Address",
  financingType: "Financing Type",
  financingDeadline: "Financing Deadline",
  inspection: "Inspection",
  inspectionDays: "Inspection Days",
  finalAcceptanceDate: "Final Acceptance Date",
  inspectionPeriodEnd: "Inspection Period Ends",
};

// Informational rows render in the panel without a checkbox and are
// never written to form state on Apply.
export const INFO_FIELDS = new Set(["inspectionDays", "finalAcceptanceDate"]);

// Backend response keys that map to a different form-state key on Apply.
// `inspectionPeriodEnd` is computed from PA line 184 + PA line 513; the
// downstream form uses `inspectionDeadline`.
export const APPLY_KEY_MAP = {
  inspectionPeriodEnd: "inspectionDeadline",
};

const currencyFmt = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export function formatFieldValue(key, value) {
  if (value === null || value === undefined || value === "") return "";
  if (CURRENCY_FIELDS.has(key)) {
    const num = typeof value === "number" ? value : Number(value);
    if (!Number.isFinite(num)) return String(value);
    return currencyFmt.format(num);
  }
  return String(value);
}

export function fieldLabel(key) {
  return FIELD_LABELS[key] || key;
}
